
export const SHUFFLE_ALL_DECKS = "SHUFFLE_ALL_DECKS";
export const DEAL_HEROES_TO_TOWN = "DEAL_HEROES_TO_TOWN";
export const DEAL_INITIAL_CARDS = "DEAL_INITIAL_CARDS";
export const RESET_PLAYER_CARDS = "RESET_PLAYER_CARDS";
export const NEXT_GAME_PHASE = "NEXT_GAME_PHASE";
export const PLAYER_KILLED = "PLAYER_KILLED";
export const RESET_GAME = "RESET_GAME";
export const DECREASE_PLAYER_HEALTH = "DECREASE_PLAYER_HEALTH";
export const DEAL_ROOM_CARD = "DEAL_ROOM_CARD";
export const BAIT_HEROES = "BAIT_HEROES";
export const UPDATE_PLAYER_TREASURE = "UPDATE_PLAYER_TREASURE";
export const NEXT_ROUND = "NEXT_ROUND";
export const ADD_BUILD_ACTIONS = "ADD_BUILD_ACTIONS"

export const BUILDING_MODE = "BUILDING_MODE"
export const BUILD_DUNGEON = "BUILD_DUNGEON";
export const DAMAGE_ROOM = "DAMAGE_ROOM"
export const CHANGE_SHOW_DISCARD_PILE = "CHANGE_SHOW_DISCARD_PILE"
export const DISCARD_CARD = "DISCARD_CARD"
export const DRAW_FROM_DISCARD = "DRAW_FROM_DISCARD"

// type for currently selected card
export const SELECT_CARD = "SELECT_CARD";

// hero positioning
export const SET_HERO_START_OF_DUNGEON = "SET_HERO_START_OF_DUNGEON";
export const MOVE_HERO_NUMBER_OF_STEPS = "MOVE_HERO_NUMBER_OF_STEPS";
export const DAMAGE_HERO = "DAMAGE_HERO";
export const HERO_KILLED = "HERO_KILLED";
export const HERO_SURVIVED = "HERO_SURVIVED"

// swapping card
export const CHANGE_USE_BUTTON_SWAPPING = "CHANGE_USE_BUTTON_SWAPPING";
export const SWAP_ROOMS = "SWAP_ROOMS";
export const CHANGE_SWAP_ROOMS_MODE = "CHANGE_SWAP_ROOMS_MODE";

export const ADD_USERNAME = "ADD_USERNAME";
export const ADD_SOUL = "ADD_SOUL";

export const ABLE_TO_DESTROY = "ABLE_TO_DESTROY";
export const DESTROY_ROOM = "DESTROY_ROOM"
